exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-ai-nav[data-v-16704eef]{display:inline-flex;flex-wrap:nowrap;gap:6px;max-width:100%;margin:0 0 16px;padding:4px;overflow-x:auto;border-radius:8px;background:#f3f4f7}.pi-ai-nav__link[data-v-16704eef]{display:inline-flex;flex:0 0 auto;align-items:center;height:32px;padding:0 12px;border-radius:6px;color:#4e5560;font-size:12px;font-weight:600;text-decoration:none;white-space:nowrap}.pi-ai-nav__link[data-v-16704eef]:focus,.pi-ai-nav__link[data-v-16704eef]:hover{color:#1d12b9;text-decoration:none}.pi-ai-nav__link[data-v-16704eef]:focus{outline:2px solid #1b59f8;outline-offset:-2px}.pi-ai-nav__link.is-on[data-v-16704eef]{background:#fff;color:#1d12b9;box-shadow:0 1px 3px rgba(0,0,0,.12)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16704eef","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/pi/piAssistantNav.vue
// module id = 1827
// module chunks = 0